// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3Jiqj","addWidgetButton":"Header_addWidgetButton__334nl","dashboardTabs":"Header_dashboardTabs__uyw0G","active":"Header_active__1z2Rz"};